import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import * as api from '../api/stock-adjustments';

export const useAdjustmentsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['stock-adjustments', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getAdjustmentsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useCreateAdjustment = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createAdjustment(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['stock-adjustments'] });
      qc.invalidateQueries({ queryKey: ['products'] });
      qc.invalidateQueries({ queryKey: ['ingredients'] });
    },
  });
};
